
export const defaultRangeData = [
    { text: "Use The",
      code: ".Range-Slider" 
    },
    { text: "Class. And Mofi Used Ion Range Slider.",
      code: "[Http://Ionden.Com/A/Plugins/Ion.RangeSlider]" 
    },
];
